module.exports = __webpack_public_path__ + "static/media/toiletExplore.25316a7d.png";